import React, { FC } from "react";
import { FallbackProps } from "react-error-boundary";
import { ExclamationCircleOutlined } from "@ant-design/icons";

const Crashed: FC<FallbackProps> = () => (
  <div className="Crashed">
    <ExclamationCircleOutlined /> Sorry this plugin has crashed!
  </div>
);

export default Crashed;
